import { render, staticRenderFns } from "./parts-category.vue?vue&type=template&id=69b01154&scoped=true&"
import script from "./parts-category.vue?vue&type=script&lang=ts&"
export * from "./parts-category.vue?vue&type=script&lang=ts&"
import style0 from "./parts-category.vue?vue&type=style&index=0&id=69b01154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b01154",
  null
  
)

export default component.exports